module.exports = __webpack_public_path__ + "img/logo.8182641d.png";